import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight, FiShield, FiBookOpen } = FiIcons;

const LeadForm = ({ title, description, ctaText }) => {
  const affiliateLink = "https://learn.augustapreciousmetals.com/apm-aff-lp-1-v3?apmtrkr_cid=1696&aff_id=5283&sub_id=YOUR_IDENTIFIER";

  return (
    <div className="bg-white p-8 rounded-3xl border border-slate-200 shadow-xl relative overflow-hidden group">
      <div className="absolute top-0 right-0 w-32 h-32 bg-yellow-400/10 rounded-bl-full -z-10 pointer-events-none"></div>
      <div className="w-14 h-14 bg-yellow-50 rounded-2xl flex items-center justify-center mb-6 border border-yellow-100">
        <SafeIcon icon={FiBookOpen} className="text-yellow-600 text-2xl" />
      </div>
      <h3 className="text-2xl font-bold text-slate-900 mb-3">{title}</h3>
      <p className="text-slate-600 mb-8 leading-relaxed">{description}</p>
      <a href={affiliateLink} target="_blank" rel="noopener noreferrer" className="w-full inline-flex items-center justify-center px-6 py-4 text-lg font-bold text-slate-900 transition-all duration-300 bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-xl shadow-md hover:shadow-xl hover:-translate-y-1" >
        {ctaText}
        <SafeIcon icon={FiArrowRight} className="ml-2" />
      </a>
      <div className="mt-6 pt-6 border-t border-slate-100 flex items-start gap-3 text-sm text-slate-500">
        <SafeIcon icon={FiShield} className="text-green-500 text-xl flex-shrink-0 mt-0.5" />
        <p className="leading-relaxed font-medium">
          100% Free Educational Resource. Recommended for portfolios over $50k.
        </p>
      </div>
    </div>
  );
};

export default LeadForm;